import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Youtube } from "lucide-react";
import { useSite } from "../contexts/SiteContext";
import useContent from "../lib/useContent";

const DEFAULT_FOOTER = {
  items: [
    { title: "Shop", links: [
      { label: "All Watches", href: "/shop" },
      { label: "Featured", href: "/shop?featured=true" },
      { label: "Limited Edition", href: "/shop?category=limited-edition" },
      { label: "Track Order", href: "/track" },
    ]},
    { title: "Company", links: [
      { label: "About", href: "/about" },
      { label: "Contact", href: "/contact" },
      { label: "Staff Login", href: "/staff/login" },
    ]},
  ],
};

export default function Footer() {
  const { settings } = useSite();
  const { data } = useContent("footer_menu", DEFAULT_FOOTER);
  const columns = data?.items?.length ? data.items : DEFAULT_FOOTER.items;

  return (
    <footer className="bg-[#0E0E0E] text-white mt-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-20 grid grid-cols-2 md:grid-cols-4 gap-12">
        <div className="col-span-2 md:col-span-1">
          <h3 className="font-display text-2xl text-white">{settings.site_name || "NAMOS ANTIQUES"}</h3>
          <p className="text-sm text-white/55 mt-3 leading-relaxed">{settings.tagline || "Timeless. Crafted. Yours."}</p>
          <div className="flex gap-4 mt-6 text-white/50">
            {settings.instagram && <a href={settings.instagram} target="_blank" rel="noreferrer" className="hover:text-copper"><Instagram size={18}/></a>}
            {settings.facebook && <a href={settings.facebook} target="_blank" rel="noreferrer" className="hover:text-copper"><Facebook size={18}/></a>}
            {settings.twitter && <a href={settings.twitter} target="_blank" rel="noreferrer" className="hover:text-copper"><Twitter size={18}/></a>}
            {settings.youtube && <a href={settings.youtube} target="_blank" rel="noreferrer" className="hover:text-copper"><Youtube size={18}/></a>}
          </div>
        </div>

        {columns.slice(0, 2).map((col, i) => (
          <div key={i}>
            <div className="text-[10px] uppercase tracking-luxe font-semibold text-copper mb-4">{col.title}</div>
            <ul className="space-y-2 text-sm text-white/65">
              {(col.links || []).map((l, j) => (
                <li key={j}>
                  {l.href?.startsWith("http") ? (
                    <a href={l.href} target="_blank" rel="noreferrer" className="hover:text-white">{l.label}</a>
                  ) : (
                    <Link to={l.href || "#"} className="hover:text-white">{l.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <div className="text-[10px] uppercase tracking-luxe font-semibold text-copper mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/65">
            <li>{settings.contact_email}</li>
            <li>{settings.contact_phone}</li>
            <li className="leading-relaxed">{settings.contact_address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 md:px-12 py-6 text-center text-[11px] uppercase tracking-luxe text-white/40">
        © {new Date().getFullYear()} {settings.site_name || "Namos Antiques"} · All rights reserved
      </div>
    </footer>
  );
}
